import { render, staticRenderFns } from "./confirmDelete.vue?vue&type=template&id=26b4e6d0&"
import script from "./confirmDelete.vue?vue&type=script&lang=js&"
export * from "./confirmDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/pixflow.app/httpdocs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('26b4e6d0', component.options)
    } else {
      api.reload('26b4e6d0', component.options)
    }
    module.hot.accept("./confirmDelete.vue?vue&type=template&id=26b4e6d0&", function () {
      api.rerender('26b4e6d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/confirmDelete.vue"
export default component.exports